module.exports = __webpack_public_path__ + "img/斜角吸附.35362461.svg";